import type { ReactNode } from 'react'

interface Props {
  /** Emoji shown in the circle above the heading; decorative only. */
  icon: string
  title: string
  children: ReactNode
  /** Optional call to action rendered below the copy. */
  action?: ReactNode
}

/** Full-page centred card for the states that replace the whole app shell. */
export function NoticePage({ icon, title, children, action }: Props) {
  return (
    <main className="flex min-h-screen items-center justify-center bg-surface-page px-4 py-12">
      <div className="w-full max-w-md rounded-lg border border-border bg-surface p-8 text-center shadow-card">
        <div
          aria-hidden="true"
          className="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-primary/10 text-2xl"
        >
          {icon}
        </div>
        <h1 className="small-headline mb-2 text-body">{title}</h1>
        <p className={`copy text-subtle${action ? ' mb-6' : ''}`}>{children}</p>
        {action}
      </div>
    </main>
  )
}
